
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.

import { defaultConfiguration } from "./configuration-files/default-configuration";

// The list of file replacements can be found in `angular.json`.
const redi = 'https://portal.red-i.com.ar/';
const rediUrl = 'https://new.red-i.com.ar/';
const rediV1 = redi + 'v1/';
const rediV2 = rediUrl + 'v2/';
export const environment = {
  version: "1.5.0",
  production: false,
  // rediApi: 'https://api-redi-dev.kozaca.com.ar/',
  rediApi: 'https://tapi.red-i.com.ar/',
  myPerfitApi: 'https://api.myperfit.com/v2',
  logOut: rediV1 + 'users/logout',
  rediApiUser: defaultConfiguration.rediApiUser,
  rediApiPass: defaultConfiguration.rediApiPass,
  rediImg : 'https://new.red-i.com.ar',
  rediBusqueda: 'https://new.red-i.com.ar/v2/resultados/',
  instituciones : 'facilities/',
  posts: '/img/posts/',
  perfilProfesional: rediV2 + 'perfil/',
  perfilUnidad: rediV2 + 'unidades/',
  defaultImage: defaultConfiguration.defaultImage,
  trackPixel: false,
};



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
